<template>
<div id="contents">

  <div id="works" class="page_contents">

    <div id="works_contents">
      <div id="works_archive_index">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/works/program/title.png" width="225" alt="WORKS" />
            <span>制作実績</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <worksPageNav/>

        <div id="works_archive_index_main" class="page_main_contents">
          <div id="works_archive_index_main_moviebox">
            <div id="sample_thumbnail">
              <p><img src="../assets/img/works/video-archive/sample_thumbnail.jpg" width="945" alt="" /></p>
            </div><!-- #sample_thumbnail -->
            <div id="archive_top_movie">
              <video id="sample" src="../assets/img/works/video-archive/archive_sample.mp4" controls="controls"  controlslist="nodownload"></video>
            </div><!-- #archive_top_movie -->
          </div><!-- #works_archive_index_main_moviebox -->
        </div><!-- #works_archive_index_main -->

        <div id="works_archive_index_body">
          <div id="works_archive_index_about">
            <h2>テレビ朝日映像アーカイブとは</h2>
            <div id="works_archive_index_about_inner">
              <p>番組・映像などを制作する方々へ、 「東映ニュース」 「朝日世界ニュース」 をはじめとする当社保有の映像を貸し出すサービスです。</p>
              <p>1904年（明治37年）の日露戦争の映像から始まる「明治・大正・昭和・平成」を記録した貴重な歴史資料や、文化遺産ともいうべきニュース映像まで。時代を記録してきた価値ある映像が当社には膨大に蓄積・保管されており、それらの各種映像を活用していただくことを目的に、データベースの整備を随時進めています。検索ページは無料でご利用いただけますので、ぜひお試しください。</p>
              <div class="photo_box">
                <p><img src="../assets/img/works/video-archive/ph01.jpg" width="300" alt="" /></p>
                <p><img src="../assets/img/works/video-archive/ph02.jpg" width="300" alt="" /></p>
                <p><img src="../assets/img/works/video-archive/ph03.jpg" width="300" alt="" /></p>
              </div><!-- .photo_box -->
            </div><!-- #works_archive_index_about_inner -->

            <p class="search_page_btn"><a href="https://vivia-library.appspot.com/" target="_blank" class="btn">テレビ朝日映像アーカイブ<br />検索ページへ</a></p>
            <p class="video-archive_guide_link">詳しいご利用方法&料金は、<router-link v-bind:to="{name:'guide_index'}">こちら</router-link></p>

            <div id="main_video">
              <div id="main_video_inner">
                <h3>保有する主な映像</h3>
                <p>1964年（昭和39年）の東京オリンピック映像や、第二次世界大戦の映像など、時代のトピックスを記録した充実のアーカイブを誇ります。メディアで利用頻度の高い映像は検索して動画を見ることができ、24時間プレビューが可能です。映像は申請いただいてから2営業日以内のお渡しとなります。</p>
                <p>・東京オリンピック　・第二次世界大戦　・激動の50年[昭和の歩み]・関東大震災前・後の東京　・東映ニュース（1959～1978の日本の世相）　・戦後史　・南極　・世界遺産　・各地の空撮　ほか</p>
              </div><!-- #main_video_inner -->
            </div><!-- #main_video -->
          </div><!-- #works_archive_index_about -->

          <div class="other_link">
            <p><a href="https://www.tv-asahipro.co.jp/pdf/archive_catalog.pdf" download="archive_catalog.pdf" target="_blank">＞カタログをダウンロードする（PDF/3.2M）</a></p>
            <p><a href="https://photoarchives.asahi.com/" target="_blank">＞写真をお探しの方はこちらをご利用ください（朝日新聞フォトアーカイブ）</a></p>
          </div><!-- .other_link -->

        </div><!-- #works_archive_index_body -->

      </div><!-- #works_archive_index -->
    </div><!-- #works_contents -->
  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
export default {
  name: 'video-archive_index',
  components: {
    worksPageNav
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)

    var obj = document.getElementById("sample");
    $("#archive_top_movie").css("display", "none");
    $('#sample_thumbnail').click(function () {
         $('#sample_thumbnail').hide();
         $('#archive_top_movie').fadeIn();
         obj.play();
     });
  }
}
</script>

<style scoped>



// WEBPACK FOOTER //
// src/components/archive_index.vue